module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dqzIvC/tc-custom/9781614233626.jpg?1688954037372",
      "alt": "This image is the cover for the book Guerrillas in Civil War Missouri, Civil War Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Guerrillas in Civil War Missouri, Civil War Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Missouri ranks third in the number of Civil War battles fought on its soil. Although some sizable actions were fought in the state, most of the battles were the result of the intense guerrilla activity. These battles are only the actions reported by Federal troops against the guerrillas. The attacks on civilians were equally as numerous. Long before the Civil War began, Missouri was deeply divided over whether slavery should be extended to neighboring Kansas. This book takes an in-depth look at the guerrilla warfare grounded in this division.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James W. Erwin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James W. Erwin is a Missouri native. He graduated from Missouri State University with a BA in mathematics. After service in the United States Army, he obtained an MA in history from the University of Missouri and a JD from the University of Missouri Law School. With his wife Vicki, Mr. Erwin lives in Kirkwood, Missouri.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0